export default "__VITE_ASSET__EHpK0To1__"